import React from "react";
const KalenderPersonal = React.lazy(() => import('./KalenderPersonal'));

export const kalenderPersonalConfig = [
    {
        path: '/apps/kalender-personal',
        element:<KalenderPersonal />,
        // permittedRole: ['pegawai']
    },
    {
        path: '/apps/kalender-personal/detailEvent/:id',
        element:<KalenderPersonal />
    }
];